module.exports = __webpack_public_path__ + "img/wb.9cd18039.png";